import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

function InstallAppButton() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [installAvailable, setInstallAvailable] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setInstallAvailable(true);
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    useEffect(() => {
        const handleAppInstalled = () => {
            console.log('App successfully installed');
            toast.success('App installed successfully!', { autoClose: 2000 });
            setDeferredPrompt(null);
            setInstallAvailable(false);
            setIsLoading(false);
        };

        window.addEventListener('appinstalled', handleAppInstalled);

        return () => {
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            setIsLoading(true);
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                // console.log('User accepted install prompt');
            } else {
                toast.info('User dismissed the install prompt', { autoClose: 2000 });
                setIsLoading(false);
            }
        } else {
            toast.success('App already installed or not installable', { autoClose: 2000 });
        }
    };

    return (
        <button className='install-btn' onClick={handleInstallClick} disabled={isLoading}>
            {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
                'INSTALL APP'
            )}
        </button>
    );
}

export default InstallAppButton;
